import * as React from 'react'
import * as _ from 'lodash'

import Stickyfill from 'stickyfilljs'

// (Stickyfill as any).forceSticky()


class Sticky extends React.Component<React.HTMLProps<HTMLDivElement>> {
  ref = React.createRef<HTMLDivElement>()

  render() {
    return <div ref={this.ref} {...this.props} />
  }

  componentDidMount() {
    if (this.ref.current) {
      // Stickyfill.addOne(this.ref.current)
    } else {
      console.log("MISSING")
    }
  }
}

export default Sticky



// WEBPACK FOOTER //
// ./src/view/Sticky.tsx